// extracted by mini-css-extract-plugin
export default {"wrapper":"carousel-items-module--wrapper--3bfed"};